export default "__VITE_ASSET__SIpbwbDq__"